import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

const DEFAULT_FORMATS = [
  'DD-MM-YYYY',
  'DD/MM/YYYY',
  'YYYY-MM-DD',
  'YYYY-MM-DDTHH:mm:ssZ',
  'YYYY-MM-DDTHH:mm:ss.SSSZ',
]

export function parseSafeDate(value, formats = DEFAULT_FORMATS) {
  if (!value && value !== 0) return null
  if (value instanceof Date) return value
  // try provided formats strictly
  for (const fmt of formats) {
    const d = dayjs(value, fmt, true)
    if (d.isValid()) return d.toDate()
  }
  // fallback to dayjs loose parse (handles ISO)
  const loose = dayjs(value)
  return loose.isValid() ? loose.toDate() : null
}

export function formatDate(date, fmt = 'DD-MM-YYYY') {
  if (!date) return ''
  return dayjs(date).format(fmt)
}

export default { parseSafeDate, formatDate }
